import type { Data } from '@puckeditor/core'
import * as React from 'react'

import { canShowQuickEdit } from '@/lib/page-editor-access'

import AdminQuickEditFab from '@/components/admin/admin-quick-edit-fab'
import NonFsdsPuckPageContent from '@/components/puck/non-fsds-puck-page-content'
import SEO from '@/components/seo/SEO'

import { useAuth } from '@/contexts/auth-context'
import { useCan } from '@/contexts/feature-flag-context'

interface NonFsdsEditablePageShellProps {
  slug: string
  seoTitle: string
  puckData: Data | null
  fallback: React.ReactNode
}

export default function NonFsdsEditablePageShell({
  slug,
  seoTitle,
  puckData,
  fallback,
}: NonFsdsEditablePageShellProps) {
  const { user } = useAuth()
  const canEdit = useCan('mode.editor')
  const showQuickEdit = canShowQuickEdit({ user, canEdit, slug })

  return (
    <>
      <SEO title={seoTitle} />
      {showQuickEdit && <AdminQuickEditFab currentPageSlug={slug} />}
      <NonFsdsPuckPageContent puckData={puckData} fallback={fallback} />
    </>
  )
}
